import AlternateGameDetails from "./alternate-game-details";
import betType from "../bet-type";
import { FormattedDollars, FormattedPoints } from "./formatted-currency";
import { getLargeBadges } from "../badges";
import PayoutStructure from "../containers/payout-structure";
import pure from "./higher-order/pure";
import React from "react";
import { trackListLong } from "../track-list";
import { winCap, placeCap, showCap } from "../score-caps";

export default pure(function GameBoardHeaderDetails({ races, tokenTypes, tournament }) {
  var tracks = trackListLong(races);
  var trackItems = Object.keys(tracks).map((track) => (
    <li key={track}>
      <dl className="tournament-table_tracks">
        <dt>
          {track}
          :
        </dt>

        <dd>
          {tracks[track]}
        </dd>
      </dl>
    </li>
  ));

  return (
    <div className="tournament-table_row tournament-table_row--details">
      <div className="tournament-table_meta tournament-table_meta--details">
        <div className="tournament-table_meta_cell tournament-table_meta_cell--prize">
          <PayoutStructure tournament={tournament} />
        </div>

        <div className="tournament-table_meta_cell tournament-table_meta_cell--details">
          <dl className="tournament-table_meta_item">
            <dt>
              Game Details:
            </dt>

            <dd>
              <ul className="tournament-table_tracks-group">
                {trackItems}

                <li>
                  <dl className="tournament-table_tracks">
                    <dt>
                      Scoring Type:
                    </dt>

                    <dd>
                      {betTypeWithMoney(tournament)}
                    </dd>
                  </dl>
                </li>

                <li>
                  <dl className="tournament-table_tracks">
                    <dt>
                      Point Bonus
                    </dt>

                    <dd>
                      <FormattedPoints value={tournament.get("points_reward")} />
                    </dd>
                  </dl>
                </li>

                <li>
                  <dl className="tournament-table_tracks">
                    <dt>
                      Minimum entries for tournament:
                    </dt>

                    <dd>
                      {tournament.get("number_of_users_required")}
                    </dd>
                  </dl>
                </li>

                <li>
                  <dl className="tournament-table_tracks">
                    <dt>
                      Maximum entries for tournament:
                    </dt>

                    <dd>
                      {tournament.get("max_users")}
                    </dd>
                  </dl>
                </li>

                <li>
                  <dl className="tournament-table_tracks">
                    <dt>
                      Maximum entries per player:
                    </dt>

                    <dd>
                      {tournament.get("max_tickets")}
                    </dd>
                  </dl>
                </li>
              </ul>
            </dd>
          </dl>

          <div className="tournament-table_badges_container">
            {getLargeBadges(tournament, false, true, races.first())}
          </div>

          <AlternateGameDetails tokenTypes={tokenTypes} tournament={tournament} />
        </div>
      </div>

      <dl className="product_info_rules">
        <dt>
          Rules:
        </dt>

        <dd>
          {rules(tournament, races.first())}

          {" "}

          <a href={window.env.officialRules}>
            More Details
          </a>
        </dd>
      </dl>
    </div>
  );
});

function betTypeWithMoney(tournament) {
  if (tournament.get("real_money")) {
    return "Live Bankroll";
  } else if (tournament.get("tournament_type") === "Survivor") {
    return betType(tournament);
  } else {
    return "$2 " + betType(tournament);
  }
}

function rules(tournament, firstRace) {
  var runnerLabel = "horse";

  if (typeof firstRace !== "undefined" && firstRace.get("track_breed_type") === "Greyhound") {
    runnerLabel = "greyhound";
  }

  if (tournament.get("tournament_type") === "Survivor") {
    return "Each race is single elimination. Your selection must finish 1st, 2nd, or 3rd for you to move on to the next race. If none of the remaining survivors make a winning selection for a race, all survivors will pass to the next race. If post times change and races are run out of order, races will still be scored & eliminated according to the order of races in the contest. All races close at about 1 minute to post.";
  } else {
    var bt = tournament.get("bet_type");

    var win, place, show;
    if (bt.indexOf("W") !== -1) {
      win = ((
        <span>
          <FormattedDollars value={winCap} />

          {" "}
          to win
        </span>
      ));
    }
    if (bt.indexOf("P") !== -1) {
      place = ((
        <span>
          ,
          <FormattedDollars value={placeCap} />

          {" "}
          to place
        </span>
      ));
    }
    if (bt.indexOf("S") !== -1) {
      show = ((
        <span>
          ,
          <FormattedDollars value={showCap} />

          {" "}
          to show
        </span>
      ));
    }

    return (
      <span>
        Each player selects one
        {" "}

        {runnerLabel}

        {" "}
        per race. Scoring is based on track payouts. All races close at about 1 minute to post. Payoffs are capped at

        {" "}

        {win}

        {" "}

        {place}

        {" "}

        {show}
        .
      </span>
    );
  }
}
